import styled from 'styled-components';
import Tokens from '@nokia-csf-uxr/freeform-design-tokens';

export default {
  FieldsRow: styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
    & > * {
      margin-right: ${Tokens.SPACING.SPACING_8}
    }
  `,
};